import filter from 'lodash/filter';
import values from 'lodash/values';
import { GET_ORDER_API_RETRY_NUM } from 'yoda-checkout-components/lib/actionTypes/PlaceOrderActionTypes';
import * as actions from '../actionTypes/CheckoutActionTypes';

const defaultState = {
    selectedAccordionIndex: 1,
    SDPU: { isExists: false },
    shipping: { isExists: false },
    payment: { isExists: true },
    isFromEditShipping: false,
    getOrderApiRetryNumber: 0,
};

export default function checkoutPageReducer(state = defaultState, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case actions.CHANGE_ACCORDION:
            return {
                ...state,
                selectedAccordionIndex: action.accordionIndex,
                nextAccordionIndex: action.accordionIndex + 1,
            };
        case actions.CHANGE_TO_NEXT_ACCORDION:
            return {
                ...state,
                selectedAccordionIndex: state.nextAccordionIndex,
                nextAccordionIndex: state.nextAccordionIndex + 1,
            };
        case actions.SET_NEXT_ACCORDION_INDEX:
            return { ...state, nextAccordionIndex: action.accordionIndex };
        case actions.VALIDATE_SHIPPING:
            return { ...state, shipping: { ...state.shipping, isValid: action.value } };
        case actions.GET_CHECKOUT_SECTIONS_INFO: {
            const prevSections = filter(values(state), { isExists: true });
            const newState = {
                ...state,
                // Maintain isValid flag to check if user has completed that section.
                SDPU: { isValid: state.SDPU && state.SDPU.isValid, ...action.payload.SDPU },
                shipping: {
                    isValid: state.shipping && state.shipping.isValid,
                    ...action.payload.shipping,
                },
                payment: {
                    isValid: state.payment && state.payment.isValid,
                    ...action.payload.payment,
                },
            };
            const newSections = filter(values(newState), { isExists: true });
            // Some section has been removed as item went OOS
            if (newSections.length < prevSections.length) {
                newState.selectedAccordionIndex =
                    state.selectedAccordionIndex > 1 ? state.selectedAccordionIndex - 1 : 1;
                newState.nextAccordionIndex =
                    state.nextAccordionIndex > 2 ? state.nextAccordionIndex - 1 : 2;
            }
            if (action.payload.selectedAccordionIndex) {
                newState.selectedAccordionIndex = action.payload.selectedAccordionIndex;
                newState.nextAccordionIndex = action.payload.selectedAccordionIndex + 1;
            }
            return newState;
        }
        case actions.IS_MOUNT_ON_SERVER:
            return { ...state, mountOnServer: action.value };
        case GET_ORDER_API_RETRY_NUM:
            return { ...state, getOrderApiRetryNumber: action.value };
        case actions.SET_CREATE_ACCOUNT_MESSAGE:
            return { ...state, createAccountMessage: action.value };
        case actions.SET_PROFILE_INFO:
            return { ...state, profileInfo: action.value };
        case actions.GET_PROMOTIONAL_EMAIL_SECTION:
            return { ...state, emailSection: action.value };
        default:
            return state;
    }
}
